import { S3_HOST } from '@app/assets';

export const getSettlementsDetailsImageUrl = (id: number, imgName?: string): string =>
  `${S3_HOST}/settlement-details/${String(id)}/${imgName ? `${imgName}.webp` : 'background.webp'}`;

export const getTrackUrl = (src: string) =>
  !/\.(.{3}$)/.exec(src) ? `${S3_HOST}/media/${src}.mp3` : `${S3_HOST}/media/${src}`;

export const calcImageTopPosition = (viewportHeight: number, baseTop: number, multiplier = 0.5) => {
  const baseHeight = 850;
  return baseTop - multiplier * (baseHeight - viewportHeight);
};
